// src/pages/Home.js 
"use client";

import React, { useMemo, useCallback, useEffect, useState } from "react";
import CourseList from "../components/CourseList";
import "../CSS/Home.css";
import { useNavigate } from "react-router-dom";
import { useTour } from "../hooks/useTour";
import { useAuth } from "../context/AuthContext";

const Home = () => {
  const { currentRole, user, logout } = useAuth();
  const roleLower = String(currentRole || "").toLowerCase();
  const navigate = useNavigate();

  // ✅ SOLO estudiantes (incluye el fallback seguro si no es admin/docente)
  const isAdmin = roleLower === "administrador" || roleLower === "admin";
  const isTeacher = roleLower === "docente" || roleLower === "asistente";
  const isStudent = roleLower === "estudiante" || (!isAdmin && !isTeacher);

  const hasAuthPhoto = Boolean(
    user?.auth_foto?.public_url ||
      user?.auth_foto?.url ||
      user?.auth_foto_url ||
      user?.authFotoUrl
  );

const tour = useTour({ storageKey: "tour:home:v1", enabled: isStudent, userKeyOverride: (user?.id || user?.email || user?.correo || "anon") });
  const steps = useMemo(
    () => [
      {
        key: "welcome",
        title: "Bienvenido 👋",
        text: "Te muestro rápidamente cómo usar el Home para entrar a tus cursos.",
        selector: null,
      },
      {
        key: "search",
        title: "Buscar cursos",
        text: "Usa el buscador para encontrar un curso por nombre o código.",
        selector: '[data-tour="home-search"]',
        shape: "rect",
        pad: 10,
      },
      {
        key: "filter",
        title: "Filtrar por tipo",
        text: "Aquí puedes ver solo cursos normales o solo examen.",
        selector: '[data-tour="home-typefilter"]',
        shape: "rect",
        pad: 10,
      },
      {
        key: "list",
        title: "Tus cursos",
        text: "Esta es tu lista de cursos. Haz click en uno para ver su contenido.",
        selector: '[data-tour="home-courses"]',
        shape: "rect",
        pad: 10,
      },
      {
        key: "continue",
        title: "Continuar",
        text: 'Presiona "Continuar" para entrar al curso y seguir tu progreso.',
        selector: '[data-tour="home-continue"]',
        shape: "rect",
        pad: 10,
      },
    ],
    []
  );

  const getTargetEl = useCallback((step) => {
    if (!step?.selector) return null;
    return document.querySelector(step.selector);
  }, []);

  const onNext = useCallback(() => {
    const isLast = tour.stepIndex >= steps.length - 1;

    // usa finishIfLast para marcar visto y cerrar automáticamente al final
    tour.finishIfLast(steps.length);
  }, [tour, steps.length]);

  return (
    <div className="home">
      <CourseList />

      
    </div>
  );
};

export default Home;
